<template>
    <div class="loader-component" v-if="isLoading">
      <div class="loader-component__circles">
        <span class="loader-component__circle"></span>
        <span class="loader-component__circle"></span>
        <span class="loader-component__circle"></span>
      </div>
    </div>
  </template>

  <script lang="ts">

  export default {
    name: "LoaderComponent",
    props: {
      isLoading: {
        type: Boolean,
        required: true,
        default: undefined,
      },

    },
    created() {
      if (this.isLoading === undefined) {
        throw new Error("isLoading prop is not defined");
      }
    },
  };
  </script>
